import { ReactNode } from 'react'

export const ASSET_DIR = '/assets/images/farmer-solution'

export const STRINGS = {
  PAGE_TITLE:
    'Farmer Application-Agricultural Solution for Farmers | Download Now',
  PAGE_DESCRPTION:
    'Agricultural solution for farmers by our DeHaat Farmers Application. Get products, crop reminder notification, voice calls, crop consultation on our farmers app.',
  PAGE_HEADING: 'Solution for farmers',
  DESCRIPTION:
    'DeHaat Farmer App is a onestop platform that provides multiple services, including frequent crop reminders, voice calls in regional languages, crop advisories, weather reports, local mandi rates, etc. to over 1.4 million farmers in 12 major agri-based states in India.\n\nFarmers can use the App to get direct consultations from Agri-experts on chemical dosage, crop health advice, and the use of high-quality input products. Purchase and sale of input or output products can also be done through the app with convenience.\n\nFarmers can avail customised advisory services based on real-time information through the app right at their fingertips.',
  ACTIVE_REGISTERED_FARMERS: 'Active registered farmer',
  ADViSORY_FOR_AGRICULTURE: 'Advisory for sustainable agriculture',
  LANGUAGES: 'DeHaat Farmer app languages',
  VALUE_CHAIN: 'Digitised crop value chain',
  DEHAAT_CENTER: 'Onestop DeHaat Centers',
  ESTIMATED_ACREAGE: 'Estimated Acreage',
  DIGITAL_SOLUTION: 'Digital Solution For Farmers',
  SOIL_TESTING: 'Soil Testing',
  SOIL_TESTING_DESC:
    'Provides information on the availability of minerals in the soil that further helps in determining the quantity of fertilizer/chemicals required for optimal crop growth.',
  FARM_TAGGING: 'Farm Tagging',
  FARM_TAGGING_DESC:
    'Gives accurate solutions through the App for pest control, crop health, crop yield and monitoring, irrigation sources, climate monitoring,usage of manure and fertilizers,flooding and drought prediction.',
  CROP_PLANNER: 'Crop Planner',
  CROP_PLANNER_DESC:
    'Gives a complete overview of crucial aspects of crop production such as type of soil, irrigation requirement, optimal weather conditions, crop health concerns, field preparations, time of sowing & harvesting, etc.',
  WEATHER_ALERTS: 'Weather Alerts',
  WEATHER_ALERTS_DESC:
    'Provides regular weather updates on various agri-based parameters along with the forecast for the coming fortnight, helps to conceptualize crop sowing and harvest status, rainfall etc.',
  QUALITY_INPUT: 'Access to Quality inputs',
  QUALITY_INPUT_DESC:
    'Enables easier and faster access to quality Agri input products with delivery right at the doorsteps of the farmers.',
  CONNECT_EXPERTS: 'Connect with Experts',
  CONNECT_EXPERTS_DESC:
    'Allows hassle-free connectivity for the farmers to learn about our Agri services, connect with experts and get faster solutions to any problems.',
  CROP_INSURANCE: 'Crop Insurance',
  CROP_INSURANCE_DESC:
    'Easy to avail and accessible policies at low-cost premium, provides a safety net for farmers in case of crop damage caused by natural calamities',
  MANDI_RATE: 'Mandi rate and Market Linkage (Sell Produce)',
  MANDI_RATE_DESC:
    'Regular information on region-wise local mandi rates of various Agri produce allows farmers to comprehend the available market rate for the best selling price of their produce which Enables farmers to sell their produce directly to the institutional buyers ',
  EXPERIENCE_FARMER_APP: 'Experience Farmer App',
  ENTER_MOBILE_NUMBER: 'Enter Your Mobile Number',
  BY_PROVIDING_NUMBER: (terms: ReactNode, privacy: ReactNode) => (
    <>
      By providing number I agree with {terms} & {privacy}
    </>
  ),
  TERM_AND_CONDITION: 'Terms and conditions',
  PRIVACY_POLICY: 'Privacy Policy',
  DOWNLOAD_APP: 'Download App',
  FIVE_A: "5 A's we offer to Empower Farmers",
  ACCESS_QUALITY_INPUT: 'Access to Quality Input',
  ACCESS_QUALITY_INPUT_DESC:
    "A fast home/field delivery service of quality Agri input products to the farmers. \n\nAccess to quality inputs helps farmers obtain better produce with right product and dosage recommendations based on their requirements. It also helps farmers avoid the hassle of travelling long distances with convenient options like 'Payment at Delivery', 'Pickup at Nearest DeHaat Center' saving them both time and money.",
  AFFORDABLE_INSURANCE: 'Access to Affordable Insurance',
  AFFORDABLE_INSURANCE_DESC:
    "A “Satellite-based parametric weather insurance” program for the farmers.\n\nUnpredictable weather poses a potential threat to the farmers' production and economic prosperity. Our affordable insurance program offers a safety net to the farmers in case of crop damage caused by natural calamities. The program is offered at a very low premium with an uncomplicated enrolment and a prompt claim settlement process.",
  FORMAL_CREDIT: 'Access to Formal Credit',
  FORMAL_CREDIT_DESC:
    'Uncomplicated financing option for farmers to purchase various farm equipment for convenient farming practices and better produce.\n\nFormal Credit to farmers solves the credit crunch that the farming sector faces so that they can purchase the required products on credit and increase their production. Farmers are also provided with the option of paying back in easy instalments.',
  ACTIONABLE_ADVISORY: 'Access to Actionable Advisory',
  ACTIONABLE_ADVISORY_DESC:
    "Renders advisory & suggestions by expert agronomists on various farming essentials.\n\nActionable Advisory aims to impart awareness about different agricultural problems and the solutions to tackle them. This initiative will also help to increase awareness of DeHaat's quality products and services in the farming community.",
  E_SAMADHAN: 'E-Samadhan',
  PROFITABLE_MARKET: 'Access to Profitable Markets',
  PROFITABLE_MARKET_DESC:
    'Enables farmers to sell their produce directly to institutional buyers and improves their income.\n\nAccess to Profitable Markets offers farmers the convenience to sell their harvest at the end of the cropping season at mandi rates without the hassle of transportation and involvement of middlemen.',
  PREMIUM_MEMBERSHIP: 'Premium Membership Program',
  PREMIUM_MEMBERSHIP_DESC:
    'A membership program for farmers to get all available solutions of DeHaat under one umbrella.\n\nAvailable at a budget-friendly rate with an annual payment option, Farmer Membership Program offers agricultural and financial services along with various unique benefits on a priority basis to the members.',
  DEHAAT_APP_EXPERIENCE: 'Get DeHaat app experience on Mobile website!',
  EASY_BROWSING_EXPERIENCE: 'Get Easy browsing experience',
  QUICK_ACCESS: 'Get quick access',
  SIMPLE_WAY: 'Simple way is to click the link below',
  VISIT_KISAAN_WEB: 'Visit Kisaan website',
}

const METRICS = {
  ACTIVE_REGISTERED_FARMERS: '1.4M+',
  ADViSORY_FOR_AGRICULTURE: '300+hrs/month',
  LANGUAGES: '6+',
  VALUE_CHAIN: '30+',
  DEHAAT_CENTER: '8000+',
  ESTIMATED_ACREAGE: '80K+ Hectare',
}

export const FEATURE_CARDS = [
  {
    heading: STRINGS.ACTIVE_REGISTERED_FARMERS,
    value: METRICS.ACTIVE_REGISTERED_FARMERS,
    image: `${ASSET_DIR}/registered-farmer`,
  },
  {
    heading: STRINGS.ADViSORY_FOR_AGRICULTURE,
    value: METRICS.ADViSORY_FOR_AGRICULTURE,
    image: `${ASSET_DIR}/sustainable-agriculture`,
  },
  {
    heading: STRINGS.LANGUAGES,
    value: METRICS.LANGUAGES,
    image: `${ASSET_DIR}/languages`,
  },
  {
    heading: STRINGS.VALUE_CHAIN,
    value: METRICS.VALUE_CHAIN,
    image: `${ASSET_DIR}/value-chain`,
  },
  {
    heading: STRINGS.DEHAAT_CENTER,
    value: METRICS.DEHAAT_CENTER,
    image: `${ASSET_DIR}/dehaat-center`,
  },
  {
    heading: STRINGS.ESTIMATED_ACREAGE,
    value: METRICS.ESTIMATED_ACREAGE,
    image: `${ASSET_DIR}/coverage`,
  },
]

export const ACCORDION_FEATURES = [
  {
    heading: STRINGS.SOIL_TESTING,
    description: STRINGS.SOIL_TESTING_DESC,
    icon: `${ASSET_DIR}/soil-testing`,
    image: `${ASSET_DIR}/phone/soil-testing`,
    imageAlt: 'Screenshot of soil testing from farmer solution app',
  },
  {
    heading: STRINGS.FARM_TAGGING,
    description: STRINGS.FARM_TAGGING_DESC,
    icon: `${ASSET_DIR}/farm-tagging`,
    image: `${ASSET_DIR}/phone/farm-tagging`,
    imageAlt: 'Screenshot of farmer tagging from farmer solutions app',
  },
  {
    heading: STRINGS.CROP_PLANNER,
    description: STRINGS.CROP_PLANNER_DESC,
    icon: `${ASSET_DIR}/crop-planner`,
    image: `${ASSET_DIR}/phone/crop-planner`,
    imageAlt: 'Screenshot of crop planner from farmer solutions app',
  },
  {
    heading: STRINGS.WEATHER_ALERTS,
    description: STRINGS.WEATHER_ALERTS_DESC,
    icon: `${ASSET_DIR}/weather-alerts`,
    image: `${ASSET_DIR}/phone/weather-alerts`,
    imageAlt: 'Screenshot of weather alerts from farmer solutions app',
  },
  {
    heading: STRINGS.ACCESS_QUALITY_INPUT,
    description: STRINGS.ACCESS_QUALITY_INPUT_DESC,
    icon: `${ASSET_DIR}/quality-input`,
    image: `${ASSET_DIR}/phone/quality-input`,
    imageAlt: 'Screenshot of quality input from farmer solutions app',
  },
  {
    heading: STRINGS.CONNECT_EXPERTS,
    description: STRINGS.CONNECT_EXPERTS_DESC,
    icon: `${ASSET_DIR}/connect-experts`,
    image: `${ASSET_DIR}/phone/connect-experts`,
    imageAlt: "Screenshot of What's app chat with experts",
  },
  {
    heading: STRINGS.CROP_INSURANCE,
    description: STRINGS.CROP_INSURANCE_DESC,
    icon: `${ASSET_DIR}/crop-insurance`,
    image: `${ASSET_DIR}/phone/crop-insurance`,
    imageAlt: 'Screenshot of crop insurance from farmer solutions app',
  },
  {
    heading: STRINGS.MANDI_RATE,
    description: STRINGS.MANDI_RATE_DESC,
    icon: `${ASSET_DIR}/mandi-rate`,
    image: `${ASSET_DIR}/phone/mandi-rate`,
    imageAlt: 'Screenshot of mandi rate from farmer solutions app',
  },
]
